import React from "react";
import { Tooltip } from "react-tooltip";
import TooltipInfoIcon from "src/img/TooltipInfoIcon";

export const TooltipComponent = ({
  id,
  content,
  width,
}: {
  id: string;
  content: string;
  width?: number;
}) => {
  return (
    <>
      <div
        className="min-w-[16px] min-h-[16px] items-center justify-center flex bg-[#403F3E] rounded-full"
        data-tooltip-id={id}
      >
        <TooltipInfoIcon id={id} height={width} width={width} />
      </div>
      <Tooltip id={id} place="bottom" variant="info" content={content} />
    </>
  );
};
